import { render, staticRenderFns } from "./AddLedger.vue?vue&type=template&id=491eb683&"
import script from "./AddLedger.vue?vue&type=script&lang=js&"
export * from "./AddLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports